import React from 'react';
import {ModalRoot} from "@vkontakte/vkui";
import {
    BUY_COINS_MODAL,
    GAME_FAILED_FINISH_MODAL,
    GAME_RESULTS_MODAL,
    GAME_SUCCESS_FINISH_MODAL,
    SUBSCRIBE_MISSIONS_MODAL,
    SUBSCRIBE_TOURNAMENT_MODAL,
    TOURNAMENT_GOOD_LUCK_MODAL
} from "../routing/routing";
import {GameResultModal} from "./Game/GameResultModal";
import {FailedFinishGameModal} from "./Game/FailedFinishGame";
import {SuccessFinishGameModal} from "./Game/SuccessFinishGame";
import {SubscribeToTournamentModal} from "./Tournament/SubscribeToTournamentModal";
import {TournamentGoodLuckModal} from "./Tournament/TournamentGoodLuckModal";
import BuyCoinsModal from "./Payment/BuyCoinsModal";
import {SubscribeToMissionsModal} from "./Missions/SubscribeToMissionsModal";

export const Modals = ({ activeModal, routeNavigator }) => {
    const closeModals = (modalID) => {
        switch (modalID) {
            case GAME_RESULTS_MODAL:
                // Не будем показывать рекламу
                break;
            default:
                break;
        }
        return routeNavigator.hideModal();
    };

    return (
        <ModalRoot activeModal={activeModal} onClose={closeModals}>
            <GameResultModal nav={GAME_RESULTS_MODAL}/>
            <SuccessFinishGameModal nav={GAME_SUCCESS_FINISH_MODAL}/>
            <FailedFinishGameModal nav={GAME_FAILED_FINISH_MODAL}/>
            <SubscribeToTournamentModal nav={SUBSCRIBE_TOURNAMENT_MODAL}/>
            <SubscribeToMissionsModal nav={SUBSCRIBE_MISSIONS_MODAL}/>
            <TournamentGoodLuckModal nav={TOURNAMENT_GOOD_LUCK_MODAL}/>
            <BuyCoinsModal nav={BUY_COINS_MODAL}/>
        </ModalRoot>
    );
};
